// extracted by mini-css-extract-plugin
export default {"KeyTakeawayNumber":"KeyTakeawayNumber_KeyTakeawayNumber__JVeYx","PrintKeyTakeawayNumber":"KeyTakeawayNumber_PrintKeyTakeawayNumber__PwK-m"};